import { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function PaymentDetails({ member, shops = [] }) {
  const [rentRows, setRentRows] = useState([]);
  const [bondsRows, setBondsRows] = useState([]);
  const [loading, setLoad] = useState(false);
  const [combinedRows, setCombinedRows] = useState([]);

  useEffect(() => {
    if (!member?.id) return;
    setLoad(true);
    Promise.all([
      api.get(`/payments/rent/${member.id}`).catch(() => ({ data: [] })),
      api.get(`/bonds/bonds/${member.id}`).catch(() => ({ data: [] }))
    ])
      .then(([rentRes, bondsRes]) => {
        const rent = (rentRes.data || []).map(r => ({ ...r, type: 'Rent', date: r.payment_date }));
        const bonds = (bondsRes.data || []).map(b => ({ ...b, type: 'Bond', date: b.bond_date }));
        setRentRows(rent);
        setBondsRows(bonds);
        const combined = [...rent, ...bonds].sort((a, b) => new Date(b.date) - new Date(a.date));
        setCombinedRows(combined);
      })
      .catch(() => toast.error('Failed to load payment details'))
      .finally(() => setLoad(false));
  }, [member?.id]);

  if (!member?.id) return (
    <div className="empty-state">
      <p>Save Personal info first to view payment details.</p>
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 24, marginBottom: 24 }}>
          <div className="card" style={{ flex: 1, padding: 16 }}>
            <p style={{ color: 'var(--text3)', fontSize: 12, marginBottom: 4 }}>Total Rent Payments</p>
            <p style={{ fontSize: 24, fontWeight: 600, color: '#1d4ed8' }}>
              Rs. {rentRows.reduce((sum, r) => sum + Number(r.amount || 0), 0).toFixed(2)}
            </p>
            <p style={{ color: 'var(--text3)', fontSize: 12 }}>{rentRows.length} payment(s)</p>
          </div>
          <div className="card" style={{ flex: 1, padding: 16 }}>
            <p style={{ color: 'var(--text3)', fontSize: 12, marginBottom: 4 }}>Total Bonds</p>
            <p style={{ fontSize: 24, fontWeight: 600, color: '#059669' }}>
              Rs. {bondsRows.reduce((sum, b) => sum + Number(b.amount || 0), 0).toFixed(2)}
            </p>
            <p style={{ color: 'var(--text3)', fontSize: 12 }}>{bondsRows.length} bond(s)</p>
          </div>
        </div>
      </div>

      {loading ? (
        <p style={{ color: 'var(--text3)', textAlign: 'center', padding: 32 }}>Loading…</p>
      ) : combinedRows.length === 0 ? (
        <div className="empty-state"><p>No payment or bond records found.</p></div>
      ) : (
        <div className="card" style={{ overflow: 'hidden' }}>
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Shop</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Image</th>
              </tr>
            </thead>
            <tbody>
              {combinedRows.map(row => (
                <tr key={`${row.type}-${row.id}`}>
                  <td>
                    <span className={`badge badge-${row.type === 'Rent' ? 'blue' : 'green'}`}>
                      {row.type}
                    </span>
                  </td>
                  <td>{shops.find(s => s.id === row.shop_id)?.shop_code || `#${row.shop_id}`}</td>
                  <td>{row.date}</td>
                  <td>Rs. {Number(row.amount).toFixed(2)}</td>
                  <td>
                    {row.image_path ? (
                      <a href={`https://meegoda.upload.lk/backend/uploads/${row.image_path}`} target="_blank" rel="noreferrer" className="badge badge-blue">
                        View
                      </a>
                    ) : (
                      <span style={{ color: 'var(--text3)' }}>—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
